import { setMessagesFailed, setMessagesFulfilled, setMessagesPending } from './actions';
import { openedChatsSelector } from '../../selectors';
import { fetchHistoryMessages } from '../../services/fetchHistoryMessages';
import { ERequestApiStatus } from '../../types/appState';
import { TMessageSchema } from '../../types/messages';
import { TThunkAction } from '../../types/redux/thunk';
import { ERequestTrigger } from '../../types/requestTrigger';
import { getPageStateLogData } from '../../utils/getPageStateLogData';

/**
 * Запрос сообщений по http
 */
export const getMessages =
  (chatId: string, trigger?: ERequestTrigger): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const {
      custom: { messagesMap },
    } = context;

    const state = getState();
    const openedChats = openedChatsSelector(state);

    const chat = openedChats[chatId];

    if (chat && chat.status === ERequestApiStatus.Pending) {
      return;
    }

    const createdAt = chat && chat.currentTimestamp ? new Date(chat.currentTimestamp).toISOString() : undefined;

    dispatch(setMessagesPending({ chatId }));

    const result = await fetchHistoryMessages(context, {
      parameters: {
        chatId,
        createdAt,
      },
      logData: getPageStateLogData(state, trigger),
    });

    const { error, response } = result;

    if (response !== null) {
      dispatch(
        setMessagesFulfilled({ chatId, messages: response.messages as unknown as TMessageSchema[], messagesMap }),
      );

      return;
    }

    dispatch(setMessagesFailed({ chatId, error }));
  };
